var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTicketButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "translateY(3px)"
    },
    id: "icon-ticket-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.695,
    height: 17.696,
    viewBox: "0 0 17.695 17.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M15.507,4.431,15.14,4.8A1.586,1.586,0,0,1,12.9,2.555l.367-.367L11.076,0,0,11.076l2.189,2.189.367-.367A1.586,1.586,0,0,1,4.8,15.14l-.367.367L6.62,17.7,17.7,6.62ZM5.862,15.471a2.624,2.624,0,0,0-3.637-3.637l-.758-.758,9.609-9.609.758.758a2.624,2.624,0,0,0,3.637,3.637l.758.758L6.62,16.229Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 1.037,
    height: 1.041,
    transform: "translate(9.599 7.36) rotate(-45)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 1.037,
    height: 1.041,
    transform: "translate(8.127 5.887) rotate(-45)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 1.037,
    height: 1.041,
    transform: "translate(11.072 8.833) rotate(-45)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTicketButton);
export default __webpack_public_path__ + "static/media/icon-ticket-button.aa960af2.svg";
export { ForwardRef as ReactComponent };